import { api } from '../../../AxiosConfig';

class PlanosService {
    create(data: any) {
        return api.post('/planos/create', data);
    }

    findAll() {
        return api.get('/planos/findAll');
    }

    getInfoById(id: string) {
        return api.get(`/planos/getInfoById/${id}`);
    }

    update(_id: string, update: any) {
        return api.post('/planos/update', { _id, update });
    }

    delete(_id: string) {
        return api.post('/planos/delete', { _id });
    }

    async findAllCliente(estabId: string) {
        // Exemplo com axios:
        return api.get('/planos/cliente/findAll', {
            params: { estabId },
        });
    }

    findClienteById(id: string) {
        return api.get(`/planos/cliente/details/${id}`);
    }
}

export { PlanosService };
